import { ColorValue,  View, ViewStyle } from "react-native";
import React from "react";
import { color_EEF3FA } from "../../assets/style/colors";
import { useSafeAreaInsets } from 'react-native-safe-area-context';

interface BaseScreenProps {
    children?: React.ReactNode;
    styles?: ViewStyle;
    statusHeight?: number;
    statusBarColor?: ColorValue;
    navBarColor?: ColorValue;
    navVis?: boolean
}

const BaseScreen = (props: BaseScreenProps) => {
    const { children, styles, statusBarColor, navBarColor, navVis } = props
    const insets = useSafeAreaInsets()
    const statusHeight = props.statusHeight ?? insets.top //||STATUSBAR_HEIGHT
    return (
        <View style={[{ flex: 1, backgroundColor: color_EEF3FA, }, styles]}>
            <View style={{ height: statusHeight, backgroundColor: statusBarColor ? statusBarColor : "white", width: "100%" }} />
            <View style={{ flex: 1 }}>
                {children}
            </View>
            {navVis && navVis && <View style={{ height: insets.bottom, backgroundColor: navBarColor ? navBarColor : statusBarColor ? statusBarColor : "white", width: "100%" }} />}
        </View>);
};

export default BaseScreen;
